import * as React from 'react';
import { FormContext, getEmptyTimeSpan } from "../context/Form";
import { DateRange } from "./DateRange";

export const DateRanges = () : JSX.Element => {
    const [data, dispatch] = React.useContext(FormContext);

    const addTimeSpan = () => {
        const newData = {...data};

        newData.time_span.push(getEmptyTimeSpan());

        dispatch(
            {
                type: 'STORE',
                payload: {
                    data:newData
                },
            }
        );
    };

    return <div className={'c-dateranges'}>
        <h2>Periodes</h2>
        { data.time_span.map((value,index) => {
            return <DateRange key={value.start_date+value.end_date} timespan={value} index={index} canDelete={data.time_span.length > 1} />
        })}
        <button className={'c-segments__add-timespan'} onClick={addTimeSpan}>Periode toevoegen</button>
    </div>;
}
